module.exports = __webpack_public_path__ + "static/media/profile-preorder-red.233ce5c1.svg";